import { create } from 'zustand';
import { AccountApi, ApiUtils, GetCreditPdfRequest, IFile, RequestStrategyEnum } from '@shared/api';
import { FileUtils } from '@shared';

interface ICreditPdfStore {
  loading: boolean;
  error: string | null;
  creditPdf: IFile | null;
  getCreditPdf: (request: { data: GetCreditPdfRequest; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditPdfStore = create<ICreditPdfStore>((set) => ({
  loading: false,
  error: null,
  creditPdf: null,

  getCreditPdf: ApiUtils.wrapperApi(async (request: { data: GetCreditPdfRequest; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditPdf(request.data, signal);
      !isPreview && FileUtils.downloadFile(result.data, request.filename);
      set({ creditPdf: isPreview ? (result ?? null) : null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ creditPdf: null, loading: false, error: null }),
}));
